import { Register, PublicMessages, WebSettings, Login, OTP, AuthCode, User } from "./_gears";

const APIExpress = {
  Register: Register,
  WebSettings: WebSettings,
  PublicMessages: PublicMessages,
  Login: Login,
  OTP: OTP,
  AuthCode: AuthCode,
  User: User
};

export default APIExpress;